module.exports = __webpack_public_path__ + "img/address.f5686274.svg";